<template>
  <v-card
    flat
    class="pa-0 mb-3"
  >
    <v-card
      flat
      class="d-flex align-center mt-3" 
    >
      <v-icon
        left
        :disabled="!auth.stripe.customer"
      >
        {{ customer.currency_icon }}
      </v-icon>
      Stripe Payment Methods
      <v-spacer />
      <v-btn
        icon
        :disabled="busy"
        :loading="busy"
        @click="fetch()"
      >
        <v-icon>mdi-sync</v-icon>
      </v-btn>
    </v-card>

    <new-payment-method
      :busy="busy"
      @busy="setBusy"
      @fetch="fetch()"
    />
    <v-container
      v-for="item in paymentMethods"
      :key="item.id"
      :value="item"
      class="px-0"
    >
      <v-chip
        filter
        filter-icon="mdi-credit-card"
        input-value="true"
        large
        outlined
        close
        close-icon="mdi-delete"
        :color="item.default ? 'green' : ''"
        @click="setDefault(item.id)"
        @click:close="confirmDelete(item.id)"
      >
        {{ item.card.brand }} ••••{{ item.card.last4 }} <br/>
        exp {{ item.card.exp_month }}/{{ item.card.exp_year }}
      </v-chip>
    </v-container>

    <are-you-sure
      :opt="areYouSure"
      @clickedNo="areYouSure.show = false"
      @clickedYes="areYouSure.show = false; deletePaymentMethod()"
    />
  </v-card>
</template>

<script>
import NewPaymentMethod from './NewPaymentMethod.vue'

export default {
  components: { NewPaymentMethod },
  data () {
    return {
      areYouSure: {
        show: false,
        text: {
          title: 'Are you sure?',
          subTitle: 'Remove this payment method'
        }
      },
      deletePMID: null,
      busy: false,
      paymentMethod: null,
      paymentMethods: [],
      customer: {}
    }
  },

  watch: {
    paymentMethods(){
      this.busy = false
      this.paymentMethod = this.paymentMethods.filter(r=>{
        return !!r.default
      })[0]
      this.$emit('paymentMethod', this.paymentMethod)
    }
  },
  
  mounted(){
    this.fetch()
  },

  methods: {
    setBusy(v){this.busy = v},
    confirmDelete(v){
      this.deletePMID = v
      this.areYouSure.show = true
    },
    async deletePaymentMethod(){
      this.setBusy(true)
      await this.api.delete(`/stripe/detach_payment_method/${this.deletePMID}`)
      this.deletePMID = null
      this.fetch()
    },

    async fetch(){
      this.busy = true
      const stripe = await this.api.get('/stripe/account')
      this.customer = stripe && stripe.customer || {}
      this.paymentMethods = stripe && stripe.payment_methods || []
      this.busy = false
    },
    
    async setDefault(paymentMethodID){
      if (paymentMethodID) {
        await this.api.post(`/stripe/set_default_payment_method/${paymentMethodID}`)
        this.fetch()
      }
    },

  }
}
</script>

